export default function ProblemSection() {
  const problems = [
    {
      icon: 'ri-brain-line',
      title: 'Decision Fatigue',
      description: 'Human inconsistency in judgment compounds over time, creating systematic patterns of error that AI systems learn and amplify at scale.'
    },
    {
      icon: 'ri-shield-cross-line',
      title: 'Bias Laundering',
      description: 'Historical biases embedded in training data are transformed into seemingly objective algorithmic decisions, obscuring their discriminatory origins.'
    },
    {
      icon: 'ri-alert-line',
      title: 'Hidden Liability',
      description: 'Organizations deploying AI systems inherit legal and ethical risks from historical human decisions without adequate safeguards or accountability mechanisms.'
    }
  ];

  return (
    <section className="py-24 bg-slate-900 text-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            The Consistency Paradox
          </h2>
          <p className="text-xl text-slate-300 leading-relaxed">
            AI industrializes human error. When we train systems on historical human decisions, we don't just replicate our best practices—we systematically encode our worst biases, inconsistencies, and failures at unprecedented scale.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-slate-800 p-8 hover:bg-slate-700 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-red-800 text-white mb-6 group-hover:bg-red-700 transition-colors">
                <i className={`${problem.icon} text-3xl`}></i>
              </div>
              <h3 className="font-serif text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                {problem.title}
              </h3>
              <p className="text-slate-300 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
